import styled from 'styled-components';
import ScrollBars from 'react-custom-scrollbars';

export const Root = styled.div`
  @keyframes shownUp {
    0% {
      opacity: 0
    }
    100% {
      opacity: 1
    }
  }
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255,255,255, .4);
  animation: .5s shownUp;
  @media(${({ theme }) => theme.devices.SM}) {
    top: 50px;
    height: calc(100vh - 50px);
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  width: 100%;
  max-width: 1200px;
  height: 100%;
  max-height: 700px;
  margin: 0 auto;
  background-color: ${({ theme }) => theme.colors.WHITE};
  box-shadow: 0 4px 15px -2px ${({ theme }) => theme.colors.BORDER_COLOR};
  font-weight: 300;
  font-size: 13px;
  border-radius: 8px;
  @media(${({ theme }) => theme.devices.LG}) {
    max-width: calc(100% - 32px);
  }
  @media(${({ theme }) => theme.devices.SM}) {
    width: 100%;
    max-height: 100%;
    height: 100%;
    max-width: 100%;
    margin: 0;
    border: none;
  }
`;

export const Controls = styled.div`
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  align-items: center;
  width: 100%;
  padding: 30px 73px;
  @media(${({ theme }) => theme.devices.SM}) {
    flex-direction: column;
    align-items: flex-start;
    padding-left: 20px;
    margin-bottom: 10px;
  }
`;

export const Title = styled.h2`
  font-weight: 900;
  font-size: 25px;
  @media(${({ theme }) => theme.devices.SM}) {
  font-size: 18px;
  }
`;

export const Logo = styled.img`
  width: 54px;
  height: 54px;
  @media(${({ theme }) => theme.devices.SM}) {
    margin-bottom: 10px;
  }
`;

export const LeftPart = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 220px;
  @media(${({ theme }) => theme.devices.SM}) {
    width: 180px;
  }
`;

export const RightPart = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  max-width: 425px;
  @media(${({ theme }) => theme.devices.SM}) {
    align-items: flex-end;
  }
`;

export const TableContainer = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 0 72px;
  overflow-y: hidden;
  overflow-x: hidden;
  @media(${({ theme }) => theme.devices.LGX}) {
    height: 400px;
  }
  @media(${({ theme }) => theme.devices.LG}) {
    overflow-x: auto;
  }
  @media(${({ theme }) => theme.devices.SM}) {
    padding: 0 20px;
    overflow-x: auto;
  }
  @media(max-height: 570px) {
    height: 350px !important;
  }
`;

export const CustomScrollbars = styled(ScrollBars)`
  //set important because inline styles are used by default in this component
  height: 400px !important; 
  width: 1060px !important;
  @media(${({ theme }) => theme.devices.LGX}) {
    height: 330px !important;
  }
  @media(max-height: 850px) {
    height: 470px !important;
  }
  @media(max-height: 720px) {
    height: 420px !important;
  }
  @media(max-height: 640px) {
    height: 360px !important;
  }
  @media(max-height: 570px) {
    height: 350px !important;
  }
`;

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;
